/**
 * Created by WebStorm.
 * User: Mehedi Hasan
 * Date: 09 Jan 2025
 * Time: 10:17 AM
 * Email: mdmehedihasanroni28@gmail.com
 */

import * as URL from "../helpers/Constants";
import axios from "axios";

export default class PMSSubscriptionConfigService {

    static getPMSSubscriptionConfig() {
        return axios.get(URL.GET_PMS_SUBSCRIPTION_CONFIG_URL, {
            ...PMSSubscriptionConfigService.getAuthHeader()
        });
    }

    static getPMSSubscriptionReportByPharmacyId(params, pharmacyId) {
        return axios.get(`${URL.REPORT_OWNER_URL}/${pharmacyId}`,
            {
                ...PMSSubscriptionConfigService.getAuthHeader(),
                params
            });
    }

    static submitPMSSubscriptionConfig(data) {
        return axios.post(URL.SUBMIT_PMS_SUBSCRIPTION_CONFIG_URL, data, {
                ...PMSSubscriptionConfigService.getAuthHeader()
            }
        );
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = {headers: {"Authorization": `Bearer ${accessToken}`}}
        return options;
    }

}